import { envConfigSelectors } from '~/selectors';
import { SelectDateTime } from '~/routes';

export const config = {
  selectablePartnersTitle: 'Choose another guide',
  SelectDate: {
    componentDecisioner: [
      {
        supports: envConfigSelectors.selectIsNewCalendarEnabled,
        component: SelectDateTime,
      },
    ],
  },
};
